module.exports = __webpack_public_path__ + "static/media/background.4d51f9e6.svg";